import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { DocTypeModel } from "../../../../models/docType.model";
import sharedStyles from "../../../../assets/shared.module.scss";
import styles from "./GeneralInforamtionDialogs.module.scss";
import { IPriority } from "../../../../models/priorities.model";
import BootstrapDialogTitle from "../../../../components/BootstrapDialogTitle";

interface DialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const DocTypesDialog: React.FC<
  DialogProps & { docTypes: DocTypeModel[] | null | undefined }
> = ({ open, setOpen, docTypes }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={styles.docTypesDialog}
      open={open}
      fullWidth
      maxWidth="md"
    >
      <BootstrapDialogTitle onClose={() => setOpen(false)}>
        {t("docTypesDialogTitle")}
      </BootstrapDialogTitle>
      <DialogContent>
        <Box>
          <table>
            <thead>
              <tr>
                <th className={styles.proposalOfDocumentTypes}>
                  {t("proposalOfDocumentTypes")}
                </th>
                <th className={styles.definition}>{t("definition")}</th>
                <th className={styles.examples}>{t("examples")}</th>
                <th className={styles.levelOfApproval}>
                  {t("levelOfApproval")}
                </th>
                <th className={styles.qualityReview}>{t("qualityReview")}</th>
              </tr>
            </thead>
            <tbody>
              {docTypes?.map((x) => (
                <tr key={`dialog_docType_${x.id}`}>
                  <td>{x.name}</td>
                  <td>{x.definition}</td>
                  <td>{x.examples}</td>
                  <td>{t(`levelOfApprovalTypes.${x.levelOfApproval}`)}</td>
                  <td>{x.qualityReview}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          className={sharedStyles.cancelButton}
          onClick={() => setOpen(false)}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ContinueDialog: React.FC<DialogProps & { action: () => void }> = ({
  open,
  setOpen,
  action,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={styles.continueDialog}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <BootstrapDialogTitle onClose={() => setOpen(false)}>
        {t("NotificationHasBeenSent")}
      </BootstrapDialogTitle>
      <DialogContent>
        <Box>
          <ul>
            <li>
              <label>{t("notificationToLeadingDepartmentsDivisions")}</label>
            </li>
            <li>
              <label>{t("notificationToKnowledgeBoard")}</label>
            </li>
            <li>
              <label>{t("notificationToKnowledgeTeam")}</label>
            </li>
            <li>
              <label>{t("notificationToLegalTeam")}</label>
              <p>{t("notificationToLegalTeamDetails")}</p>
            </li>
            <li>
              <label>{t("notificationToStakeholders")}</label>
            </li>
          </ul>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.continue}
          onClick={() => {
            action();
            setOpen(false);
          }}
        >
          {t("continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ContinueDeleteDialog: React.FC<
  DialogProps & { action: () => void }
> = ({ open, setOpen, action }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={styles.continueDialog}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <BootstrapDialogTitle onClose={() => setOpen(false)}>
        {t("NotificationHasBeenSent")}
      </BootstrapDialogTitle>
      <DialogContent>
        <Box>
          <ul>
            <li>
              <label>{t("notificationToLeadingDepartmentsDivisions")}</label>
            </li>
            <li>
              <label>{t("notificationToKnowledgeBoard")}</label>
            </li>
            <li>
              <label>{t("notificationToKnowledgeTeam")}</label>
            </li>
          </ul>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.continue}
          onClick={() => {
            action();
            setOpen(false);
          }}
        >
          {t("continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const RolesDialog: React.FC<DialogProps> = ({ open, setOpen }) => {
  const { t } = useTranslation();

  return (
    <Dialog className={styles.rolesDialog} open={open} fullWidth maxWidth="md">
      <BootstrapDialogTitle onClose={() => setOpen(false)}>
        {t("rolesDialogTitle")}
      </BootstrapDialogTitle>
      <DialogContent>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc at
          pulvinar ipsum. Proin pulvinar ligula id tristique imperdiet. Donec
          auctor rutrum mattis. Duis aliquam lectus leo, eget rutrum purus
          scelerisque sit amet. Donec fermentum, est vitae tempus porttitor,
          risus tortor bibendum tortor, in sodales tellus lorem ac tortor.
        </p>
        <p>
          Interdum et malesuada fames ac ante ipsum primis in faucibus. Nullam
          lobortis porttitor ultrices. Lorem ipsum dolor sit amet, consectetur
          adipiscing elit. Morbi nec ornare nisi. In eget bibendum dui, vitae
          sodales arcu. Vivamus gravida, elit id aliquam efficitur, neque arcu
          pharetra tellus, in porta diam magna id urna. Morbi elementum congue
          finibus. Phasellus non purus elementum, laoreet felis et, commodo
          felis. Integer arcu ligula, tristique in aliquet sed, hendrerit vel
          elit. Nulla et libero at diam laoreet suscipit non auctor odio.
        </p>
        <p>
          Fusce maximus magna maximus, rutrum nunc quis, fermentum odio. Mauris
          finibus vulputate tincidunt. Proin ullamcorper elit et lacus placerat,
          sit amet mollis urna feugiat. Mauris vitae iaculis enim. Vestibulum
          tristique turpis quis risus tempor congue. Cras lacinia pellentesque
          tempor. Nulla tempus leo a nulla viverra, in lobortis leo ornare. Duis
          varius lorem in leo fermentum, ut dapibus leo pellentesque. Curabitur
          finibus arcu et sem aliquam congue. Vestibulum ante ipsum primis in
          faucibus orci luctus et ultrices posuere cubilia curae; Vestibulum
          magna magna, tristique ut cursus vitae, facilisis sit amet ligula.
          Pellentesque laoreet volutpat elit.
        </p>
      </DialogContent>
      <DialogActions>
        <Button
          className={sharedStyles.cancelButton}
          onClick={() => setOpen(false)}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const PrioritiesDialog: React.FC<
  DialogProps & { priorities: IPriority[] | null }
> = ({ open, setOpen, priorities }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={styles.prioritiesDialog}
      open={open}
      fullWidth
      maxWidth="md"
    >
      <BootstrapDialogTitle
        onClose={() => setOpen(false)}
      ></BootstrapDialogTitle>
      <DialogContent>
        {priorities?.map((x) => (
          <Box key={`dialog_priority_${x.id}`}>
            <h3>{`${x.topic} (${x.name})`}</h3>
            <p>{x.description}</p>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          className={sharedStyles.cancelButton}
          onClick={() => setOpen(false)}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
